import React from 'react'
import './experience.css' 
import {BsPatchCheckFill} from 'react-icons/bs'

const experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I have</h5>
      <h2>My Experience</h2>

     <div className=" container experience_container">
      <div className="experience_webdev">
        <h3>Web Development</h3>
        <div className="experience_content">
          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Frontend Development</h4>
            <small className='text-light'>Html, Css, JavaScript, ReactJs</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Backend Development and APIs</h4>
            <small className='text-light'>Node.js, Python, RESTful APIs</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Database and Hosting</h4>
            <small className='text-light'>SQL, Firebase</small>
            </div>
          </article>

        </div>
      </div>
      {/* END OF WEB DEVELOPMENT */}

     <div className="experience_mobile">
     <h3>Mobile Development</h3>
        <div className="experience_content">
          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Cross-Platform and Native Development</h4>
            <small className='text-light'>Flutter, React Native</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Architecture and Design Patterns</h4>
            <small className='text-light'>MVC, MVP, MVVM</small>
            </div>
          </article>     
        </div>
     </div>
      {/* END OF MOBILE DEVELOPMENT */} 

    <div className="experience_IoT">
        <h3>Internet of Things (IoT)</h3>
        <div className="experience_content">
          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Hardware Integration </h4>
            <small className='text-light'>Arduino, Esp32, Nvida Jetson</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Low-Level Programming </h4>
            <small className='text-light'>C, C++, Python</small>
            </div>
          </article>
        </div>
      </div>
      {/* END OF  IOT DEVELOPMENT */}

      <div className="experience_AI">
        <h3>Artificial Intelligence</h3>
        <div className="experience_content">
          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Machine Learning</h4>
            <small className='text-light'>Predictive Modeling, Classification, Clustering</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Data Science</h4>
            <small className='text-light'>Data Analysis, Visualization, Statistical Modeling</small>
            </div>
          </article>

          <article className='experience_details'>
            <BsPatchCheckFill className='experience_details-icon'/>
            <div>
            <h4>Deep Learning</h4>
            <small className='text-light'>Neural Networks, TensorFlow, PyTorch</small>
            </div>
          </article>

        </div>
      </div>
      {/* END OF AI/ML DEVELOPMENT */}

     </div>
      
    </section>
  )
}

export default experience